import { useState } from "react";
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import Typography from '@mui/material/Typography';
import ShowContentDialog from "../../Project/ImageList/ShowContentDialog";

const items = [
  {
    img: 'https://images.unsplash.com/photo-1533827432537-70133748f5c8',
    title: 'Viktiga projektnyheter',
    author: 'Video med viktig information',
    videoUrl: 'ffdjeYkdXKE'
  },
  {
    img: 'https://images.unsplash.com/photo-1551963831-b3b1ca40c98e',
    title: 'Uppdragsbeskrivning',
    author: 'Mål, riskhantering, beslut mm',
    pdfUrl: 'https://uq.unq.se/webapi/pdf/uppgiftsbeskrivning_150124.pdf'
  },
  {
    img: 'https://images.unsplash.com/photo-1551782450-a2132b4ba21d',
    title: 'Tvåfaktorsautentisering',
    author: 'Därför behövs tvåfaktorsautentisering',
    pdfUrl: 'https://uq.unq.se/webapi/pdf/Behovsanalys%20Tvafaktorsautentisering%20Kommunal%202024.pdf'
  },
  {
    img: 'https://images.unsplash.com/photo-1522770179533-24471fcdba45',
    title: 'Wilmas inloggningstjänst',
    author: 'Använd Kommunals inloggningstjänst',
    pdfUrl: 'https://uq.unq.se/webapi/pdf/Behovsanalys%20Anvanda%20Kommunals%20inloggningstjanst%20till%20Wilma%202024.pdf'
  },
];

const getSettings = (layout, other) => {
  const { fontColor, name } = layout;

  return { fontColor, name, ...other }
};

const ProjectKeyResourcesWidget = ({ layout }) => {
  const settings = getSettings(layout);

  const [dialogContent, setDialogContent] = useState(null);

  const sxContainer = {
    backgroundColor: "transparent",
    color: settings.fontColor,
    display: "flex",
    flexGrow: 1,
    p: 2,
    "& > div": {
      width: "100%",
    },
  };

  const sxTitle = {
    fontSize: "16px",
    margin: "0px",
    padding: "0px 8px 8px 8px",
    textAlign: "center",
  };

  const closeDialog = () => setDialogContent(null);
  const openDialog = (item) => setDialogContent(item);

  return (
    <Box sx={sxContainer}>
      <Box component="div">
        <Typography variant="body1" sx={sxTitle}>
          {settings.name}
        </Typography>
        <ImageList sx={{ width: "100%" }} cols={4}>
          {items.map((item) => (
            <ImageListItem key={item.img} style={{ cursor: "pointer" }} onClick={_ => openDialog(item)}>
              <img
                srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                src={`${item.img}?w=248&fit=crop&auto=format`}
                alt={item.title}
                loading="lazy"
              />
              <ImageListItemBar
                title={item.title}
                subtitle={<span>{item.author}</span>}
                position="below"
              />
            </ImageListItem>
          ))}
        </ImageList>
        {dialogContent && (
          <ShowContentDialog
            onClose={closeDialog}
            open={dialogContent != null}
            selectedValue={dialogContent}
          />
        )}
      </Box>
    </Box>
  );
};

export default ProjectKeyResourcesWidget;
